module.exports = __webpack_public_path__ + "img/Icon__Beating.363b7f74.svg";